import Vue from 'vue'
import VueRouter from 'vue-router'
import Configuracion from '../components/configuracion/Container'
import ofertasPendientes from '../components/ofertasPendientes/Container'
import pedidosPendientes from '../components/pedidosPendientes/Container'
import historicoOfertas from '../components/historicoOfertas/Container'
import Login from '../components/login/LoginForm'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/configuracion',
      name: 'configuracion',
      meta: {
        menuText: 'Configuración',
        title: 'Configuración',
        requiresAuth: true,
      },
      component: Configuracion
    },
    {
      path: '/ofertas-pendientes',
      name: 'ofertasPendientes',
      meta:{
          title: 'Ofertas Pendientes',
          requiresAuth: true
      },
      component: ofertasPendientes
    },
    {
      path: '/pedidos-pendientes',
      name: 'pedidosPendientes',
      meta:{
          title: 'Pedidos Pendientes',
          requiresAuth: true
      },
      component: pedidosPendientes
    },
    {
      path: '/historico-Ofertas',
      name: 'historicoOfertas',
      meta:{
          title: 'Historico Ofertas',
          requiresAuth: true
      },
      component: historicoOfertas
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      component: {
          template: '<div>404 Página no encontrada</div>'
      }
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to.matched[0].path);
  if(to.matched[0].path === '*'){ // La ruta no existe
    if (!store.state.login.isAuth) { // No está autenticado
      next({
        name: 'login'
      });
    }else{
      next({
        name: 'home'
      });
    }
  }else{
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // Esta ruta requiere autenticación, verificamos si está logueado
      // si no, lo redirigimos a la página de login.
      if (!store.state.login.isAuth) {
        next({
          name: 'login'
        });
      } else {
        next(); // Este next deja pasar al usuario a la ruta que estaba solicitando
      }
    } else {
      //console.log(to.name+' === login && '+store.state.login.isAuth);
      if(to.name === 'login' && store.state.login.isAuth){
        next({
          name: 'ofertasPendientes'
        });
      }else{
        next(); // make sure to always call next()!
      }
    }
  }
});

export default router
